// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  storageTokenKeyName: 'Oujat-Agent-accessToken',
  storageUserDataKeyName: 'Oujat-Agent-userData',
  googleClientId: '385510799605-q5eccaiml0bo5f7cu9ivemqniqg4vqpc.apps.googleusercontent.com'
}
